<section class="stc-legales">
    <div class="container">
        <div class="row">
            <div class="col-md-12 my-auto">
                <h1>
                    BASES DEL SORTEO DE EGRESADOS ANÁHUAC 2025
                </h1>
            </div>
        </div>
    </div>
</section>



<section class="stc-legal">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="container-legal" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="3000">

                    <p>
                        <strong class="strong">Denominación del sorteo: </strong>SORTEO DE EGRESADOS ANÁHUAC 2025
                    </p>
                    <p>
                        <strong class="strong">Permiso otorgado por la Secretaría de Gobernación con el número:
                        </strong> 20250121PS06
                    </p>
                    <p>
                        <strong class="strong">Vigencia del permiso: </strong>Del 03 de julio de 2025 al 17 de octubre
                        de 2025.
                    </p>
                    <p>
                        <strong class="strong">Vigencia de la promoción: </strong> Del 03 de julio de 2025 al 10 de
                        octubre de 2025.

                    </p>
                    <p>
                        <strong class="strong">Número de folios electrónicos emitidos:</strong>El número de folios
                        electrónicos que se
                        emitirán, tendrán como máximo de folio, el marcado con el número 999999, por lo que el número de
                        folios electrónicos iniciarán con el número 000001 otorgándose de manera consecutiva y dicha
                        numeración terminará en el folio que coincida con el último egresado que haya registrado y
                        actualizado sus datos hasta las 23:59:59 horas del día 10 de octubre del 2025.
                        Número de premios a otorgar: 1 premio de primer lugar y 1 premio de segundo lugar directo a los
                        ganadores.
                    </p>

                    <p>
                        <strong class="strong">Valor del primer premio: </strong> $100,000.00 (cien mil pesos 00/100
                        M.N.) que consiste en un Cheque Certificado por la cantidad de $100,000.00 (cien mil pesos
                        00/100 M.N.)


                    </p>
                    <p>
                        <strong class="strong">
                            Condición de participación:
                        </strong>
                    </p>

                    <ol>
                        <li>
                            Podrán participar, todos los EGRESADOS de la Red de Universidades Anáhuac y el Instituto
                            Juan Pablo II que actualicen sus datos personales a través de la página web del Sorteo
                            Anáhuac y que este año lo realicen.
                        </li>
                        <li>
                            Los egresados deberán ingresar inicialmente a la página web del Sorteo Anáhuac
                            www.sorteoanahuac.mx y actualizar sus datos personales en la sección propia para egresados.
                        </li>
                        <li>
                            Después de una validación interna y dando visto bueno al registro de actualización se
                            generará un folio electrónico de participación para el SORTEO DE EGRESADOS ANÁHUAC 2025
                        </li>
                        <li>
                            El egresado solamente tendrá un solo folio electrónico de participación independientemente
                            del número de veces que entre a la página web a actualizar su información.
                        </li>
                        <li>
                            Para el caso de aquellos egresados que tengan dos números de matrícula, recibirán, en caso
                            de actualizar la información, un folio de participación por cada matrícula actualizada.
                        </li>
                        <li>
                            La fecha límite para la actualización de datos es hasta el día 10 de octubre de 2025 a las
                            23:59:59 horas.
                        </li>
                    </ol>

                    <p>
                        Los egresados participantes, podrán verificar en la página web del Sorteo Anáhuac
                        www.sorteoanahuac.mx, las bases del sorteo (ANEXO 1), así como su folio electrónico de
                        participación, ésta consulta la podrán hacer a partir del 15 de octubre de 2025. Los egresados
                        reciben su folio de participación al cumplir con las condiciones de participación.
                    </p>

                    <p>
                        <strong class="strong">
                            Mecánica del sorteo:
                        </strong>
                    </p>

                    <p>
                        La mecánica del SORTEO DE EGRESADOS ANÁHUAC 2025 será por formación de números:
                    </p>

                    <ol>
                        <li>Se pondrá a la vista del Inspector que para tal efecto se designe, 1 (una) mesa la cual
                            cuenta con 5 (cinco) ánforas, unidas por un eje horizontal.</li>
                        <li>En las 4 (cuatro) primeras ánforas, de derecha a izquierda, se colocarán 10 (diez) esferas
                            con la numeración del 0 (cero) al 9 (nueve), representarán las unidades, decenas, centenas y
                            unidades de millar, la 5ª (quinta) ánfora, en caso de ser necesario, representará las
                            decenas de millar, así como las centenas de millar, dependiendo del número de folios
                            participantes se pondrá el número de ánforas y esferas necesarias empezando del 0 y hasta el
                            número que sea necesario.</li>
                        <li>En cada ánfora (del 1 a la 5), saldrá una esfera formando el número ganador.</li>
                        <li>Cabe señalar que la formación de los números ganadores se hará de derecha a izquierda y su
                            lectura de izquierda a derecha.</li>
                        <li>En el caso de que el número formado esté fuera de la emisión del número total de folios, el
                            premio volverá a sortearse entre los folios participantes</li>
                        <li>Los premios 1 y 2 (uno y dos) se sortearán entre los Egresados. Los premios se otorgarán de
                            manera directa y que corresponde al total de premios que se sortearán en el SORTEO DE
                            EGRESADOS ANÁHUAC 2025.</li>
                        <li>En caso de que, al momento en que estén corriendo las esferas, alguna se atore, se repetirá
                            el procedimiento.</li>
                    </ol>


                    <p>
                        <strong class="strong">Lugar, fecha y hora del concentrado:</strong> 17 de octubre de 2025 a las
                        10:15 horas, en las instalaciones de la Universidad Anáhuac México Campus Sur con domicilio en
                        Avenida de los Tanques no. 865, Colonia Torres de Potrero, C.P. 01840, Alcaldía Álvaro Obregón,
                        Ciudad de México.
                    </p>
                    <p>
                        <strong>
                            Lugar, fecha y hora del sorteo:
                        </strong> 17 de octubre de 2025 a las 10:30 horas en las instalaciones de la Universidad Anáhuac
                        México Campus Sur con domicilio en Avenida de los Tanques no. 865, Colonia Torres de Potrero,
                        C.P. 01840, Alcaldía Álvaro Obregón, Ciudad de México.
                    </p>

                    <p>
                        <strong class="strong">Acceso libre y gratuito al evento del sorteo para todo el
                            público.</strong>
                    </p>

                    <p>
                        <strong>Entrega del premio: </strong> El premio será pagado y entregado de conformidad con lo
                        establecido en las bases de Sorteo, como el premio, es menor a 1,500 (UMA). $169,710.00 (Ciento
                        sesenta y nueve mil setecientos diez pesos 00/100 m.n.) la entrega, se realizará dentro de los
                        20 (veinte) días hábiles contados a partir de la celebración del sorteo, en Avenida Universidad
                        Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de


                        México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves de 10:00 a 18:00 horas y
                        los viernes de 10:00 a 14:00 horas.

                    </p>

                    <p>
                        Para el caso en que el premio sea un cheque, previo acuerdo con el ganador, éste tendrá tres
                        opciones:
                    </p>

                    <ul>
                        <li>
                            Se procederá a realizar el depósito del cheque del premio a una cuenta bancaria a nombre del
                            ganador fungiendo la ficha de depósito como acuse de recibo por parte del ganador misma que
                            se anexará al formato de acuse de recibo.
                        </li>
                        <li>
                            Por otro lado, en caso de que el ganador prefiera una transferencia bancaria se hará el
                            depósito y se adjuntará en el acuse de recibo el comprobante bancario de la transferencia a
                            nombre del ganador.
                        </li>
                        <li>
                            En caso de que el ganador así lo prefiera, se le entregará el cheque nominativo con acuse de
                            recibo.
                        </li>
                    </ul>


                    <p>
                        En los tres casos, para la comprobación de entrega de premios a los ganadores, se realizará
                        conforme a los lineamientos de ley con un acuse de recibo en donde se describe el premio al
                        ganador.
                    </p>
                    <p>
                        Para recibir su premio, el colaborador ganador deberá mostrar una identificación oficial vigente
                        con fotografía (credencial del IFE, credencial del INE o Pasaporte) y el acto será ante el
                        inspector asignado por la Dirección General de Juegos y Sorteos.
                    </p>
                    <ul>
                        <li>Redes Sociales del sorteo:
                            <ol type="a">
                                <li>FaceBook: <a href="https://www.facebook.com/SorteoAnahuac/?locale=es_LA"
                                        target="_blank">https://www.facebook.com/SorteoAnahuac/?locale=es_LA</a>
                                </li>
                                <li>Twitter: <a href="https://twitter.com/sorteoanahuac?lang=es"
                                        target="_blank">https://twitter.com/sorteoanahuac?lang=es</a>
                                </li>
                                <li>Instagram: <a href="https://www.instagram.com/sorteoanahuac/?hl=es"
                                        target="_blank">https://www.instagram.com/sorteoanahuac/?hl=es</a>
                                </li>
                            </ol>
                        </li>
                        <li>Página web: <a href="http://www.sorteoanahuac.mx" target="_blank">www.sorteoanahuac.mx</a>
                        </li>
                    </ul>

                    <p>
                        <strong class="strong">
                            Publicación de Resultados:
                        </strong>
                        Para el sorteo denominado SORTEO DE EGRESADOS ANÁHUAC 2025. La lista de ganadores, será
                        publicada (el número ganador, el nombre propio y la ciudad en donde reside el ganador) con base
                        a nuestro aviso de privacidad; la Ley Federal de Juegos y Sorteos y su Reglamento en relación
                        con la Ley Federal de Protección a Datos Personales en Posesión de Particulares en nuestra
                        página web www.sorteoanahuac.mx. El resultado estará disponible a partir del día 18 de octubre
                        de 2025. Por otro lado, existirá una publicación de resultados con el nombre completo del
                        ganador y a la vista de todo el público en las instalaciones del Sorteo Anáhuac en Avenida
                        Universidad Anáhuac no. 46 Colonia Lomas Anáhuac, C.P. 52786, Huixquilucan Estado de México.
                    </p>

                    <p>
                        Por disposición de la Secretaría de Gobernación, se deberá cumplir con los siguientes
                        requisitos:
                    </p>

                    <ul>
                        <li>
                            La persona beneficiada con el premio, deberá presentar una identificación oficial vigente
                            con fotografía.
                            <ol type="1">
                                <li>El premio será pagado de conformidad con lo establecido en las bases del sorteo
                                    conforme a lo señalado en el artículo 121 del Reglamento de la Ley Federal de Juegos
                                    y Sorteos.</li>
                                <li>Los impuestos, derechos y gastos de entrega del premio al ganador, estarán a cargo
                                    del Sorteo Anáhuac A.C.</li>
                                <li>Al asentar sus datos personales reconoce que se le ha informado del aviso de
                                    privacidad citado en nuestra página web <a
                                        href="http://www.sorteoanahuac.mx" target="_blank">www.sorteoanahuac.mx</a>.</li>
                                <li>Para cualquier aclaración o información referente a este sorteo o resultados del
                                    mismo, comunicarse al teléfono 555328-8096 ext. 2137 o acudir a Av. Universidad
                                    Anáhuac número 46, Col. Lomas Anáhuac, C.P. 52786 en Huixquilucan, Estado de México.
                                </li>
                                <li>En caso de queja, acudir a la Dirección General de Juegos y Sorteos de la Secretaría
                                    de Gobernación, ubicada en Versalles número 49, 2do. Piso, Col. Juárez, Alcaldía
                                    Cuauhtémoc, C.P. 06600, Ciudad de México, o bien comunicarse al teléfono
                                    555209-8800.</li>
                                <li>Responsable del sorteo: Sorteo Anáhuac A.C. con domicilio en Av. Universidad Anáhuac
                                    no. 46 Col. Lomas de Anáhuac, C.P. 52786, Huixquilucan, Estado de México, teléfono:
                                    555328-8096.</li>
                            </ol>
                        </li>
                    </ul>


                </div>
            </div>
        </div>
    </div>
</section>